<script>
	import Header from '../page/side/_header.svelte'
    import Footer from '../page/side/_footer.svelte'
    import ViewTitle from '../page/play/viewTitle.svelte'
    import ViewButton from '../page/play/viewButton.svelte'
    import ViewInfo from '../page/play/viewInfo.svelte'
    import ViewMonsters from '../page/play/viewMonsters.svelte'

	import { onMount } from 'svelte'
	import { navigate  } from 'svelte-routing'
    import { SettingCheck } from '../script/_init'
    import { CheckDevice } from '../script/_handle'
    import { PlayData, SuggestionTemperament } from '../script/handle/play'

    export let Num
    let checkDevice = 1
    let Info = [true, true, true, true]
    let Temperament = []

    let data, CountTimer
    PlayData.subscribe(value => { data = value })
    
	onMount(async () => {

        if(Num > 0 && data.title == undefined) {
            CountTimer = 3

            let intervalId = setInterval(() => {
                CountTimer--
                
                if(CountTimer <= 0) {
                    clearInterval(intervalId)

                    navigate("/detail/"+Num, { replace: true })
                }
            }, 1000)
        } else {
            checkDevice = CheckDevice()

            // 페이지 초기 세팅
            //await Initialsetting()

            Temperament = await SuggestionTemperament(data.monsterData)
        }
    })
</script>

<svelte:window on:resize={() => checkDevice = CheckDevice()} />

<svelte:head>
	<title>던전스쿼드 팀빌딩_Play Mod</title>
</svelte:head>

<Header />

<div class="page">
    {#if checkDevice == 1}
        <div class="adfit pc vertical">
            <ins class="kakao_ad_area" style="display:none;"
            data-ad-unit = "DAN-FiXDp3vAveansjCX"
            data-ad-width = "160"
            data-ad-height = "600"></ins>
        </div>
    {:else}
        <div class="adfit mobile horizon">
            <ins class="kakao_ad_area" style="display:none;"
            data-ad-unit = "DAN-ejTHClwjUeFmA2p2"
            data-ad-width = "320"
            data-ad-height = "50"></ins>
        </div>
    {/if}

    <div class="content">
        {#if CountTimer > 0}
            <div class="not">
                <h2>Page Not Found</h2>
                <p>
                    Sorry, the page you're looking for doesn't exist.
                    Waiting for {CountTimer} second...
                </p>
                <p>
                    죄송합니다, 해당 페이지는 없는 페이지입니다.
                    {CountTimer} 초 후 이동합니다...
                </p>
            </div>
        {:else}
            {#if $SettingCheck}
                <ViewTitle />
                
                <ViewButton
                    bind:Info
                    bind:Num
                    bind:DataCheck={data.data}
                />
            {/if}

            <div class="adfit mobile horizon">
                <ins class="kakao_ad_area" style="display:none;"
                data-ad-unit = "DAN-Ts61CY3bo3stg7DB"
                data-ad-width = "320"
                data-ad-height = "50"></ins>
            </div>

            {#if $SettingCheck}
                {#if Info[0] || Info[1] || Info[2]}
                    <ViewInfo
                        bind:Info
                        bind:Memo={data.memo}
                        bind:Formation={data.formation}
                        bind:Brilliance={data.brilliance}
                        bind:Temperament={Temperament}
                    />
                {/if}

                <ViewMonsters
                    bind:Info
                    bind:Monsters={data.monsterData}
                    bind:DataCheck={data.data}
                />
            {/if}
        {/if}
    </div>

    {#if checkDevice == 1}
        <div class="adfit pc vertical">
            <ins class="kakao_ad_area" style="display:none;"
            data-ad-unit = "DAN-ReGZIZUzMcwgqh1n"
            data-ad-width = "160"
            data-ad-height = "600"></ins>
        </div>
    {:else}
        <div class="adfit mobile horizon">
            <ins class="kakao_ad_area" style="display:none;"
            data-ad-unit = "DAN-eDXKnSwlGWeojks3"
            data-ad-width = "320"
            data-ad-height = "50"></ins>
        </div>
    {/if}

	<!-- Kakao Adfit -->
	<script type="text/javascript" src="//t1.daumcdn.net/kas/static/ba.min.js" async></script>
</div>

<Footer />

<style lang='scss'>
    .not {
        padding: 20px;

        h2 {
            margin: 0px;
            color: $cl4;
            font-size: 30px;
            font-family: aggro;
        }

        p {
            color: $cl2;
            font-size: 16px;
        }
    }
</style>